import {useDispatch} from 'react-redux';
import PipettingProfileWrapper from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileWrapper';
import {
  setTaskMixingCycle,
  setTaskMixingPositionAspirate,
  setTaskMixingPositionDispense,
  setTaskMixingSpeed,
  setTaskMixingVolume,
  setTaskRetractSpeed,
} from 'stores/actions/cardStateAction';
import PipettingProfileItems from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileItem/PipettingProfileItems';
import PropTypes from 'prop-types';
import {updateRunningProtocol} from 'stores/business/protocolManagementBusiness';
import {useState} from 'react';
import PipettingProfileExpanderButton from 'contents/ProtocolEditor/TaskList/PipettingProfile/PipettingProfileExpanderButton';
import {globalAddUndoItem} from 'stores/business/undoRedoBusinessAction';
import './MixingPipettingProfile.scss';
import {TaskType} from 'constants/dataEnum';

function MixingPipettingProfile({task, runtimeMode, showRetractSpeed}) {
  const [isPipettingProfileExpanded, setIsPipettingProfileExpanded] = useState(false);

  const {ID: taskId} = task || {};

  const dispatch = useDispatch();

  const postUpdateAction = () => {
    if (runtimeMode) {
      dispatch(updateRunningProtocol());
    } else {
      dispatch(globalAddUndoItem());
    }
  };

  const updatePipettingValue = (updateFunction, value) => {
    dispatch(updateFunction(taskId, value));

    postUpdateAction();
  };

  const setMixingCycle = (value) => updatePipettingValue(setTaskMixingCycle, value);
  const setMixingPositionAspirate = (value) => updatePipettingValue(setTaskMixingPositionAspirate, value);
  const setMixingPositionDispense = (value) => updatePipettingValue(setTaskMixingPositionDispense, value);
  const setMixingSpeed = (value) => updatePipettingValue(setTaskMixingSpeed, value);
  const setRetractSpeed = (value) => updatePipettingValue(setTaskRetractSpeed, value);
  const setVolume = (value) => updatePipettingValue(setTaskMixingVolume, value);

  return (
    <div className="simple-transfer-pipetting-profile">
      {isPipettingProfileExpanded && (
        <PipettingProfileWrapper>
          <PipettingProfileItems.MixingDetailGroup
            task={task}
            onChangeCycle={setMixingCycle}
            onChangeMixingPositionAspirate={setMixingPositionAspirate}
            onChangeMixingPositionDispense={setMixingPositionDispense}
            onChangeMixingSpeed={setMixingSpeed}
            onChangeVolume={setVolume}
            showMixingVolume={task.type !== TaskType.MIXING}
          />
          {showRetractSpeed ? <PipettingProfileItems.RetractSpeed task={task} onChange={setRetractSpeed} /> : ''}
        </PipettingProfileWrapper>
      )}
      <PipettingProfileExpanderButton isExpanded={isPipettingProfileExpanded} onClick={setIsPipettingProfileExpanded} />
    </div>
  );
}

MixingPipettingProfile.propTypes = {
  task: PropTypes.object.isRequired,
  showRetractSpeed: PropTypes.bool.isRequired,
  runtimeMode: PropTypes.bool,
};

MixingPipettingProfile.defaultProps = {
  runtimeMode: false,
};

export default MixingPipettingProfile;
